import React from "react";
import { Paperclip } from "lucide-react";

interface FilePreviewProps {
  selectedFile: File | null;
  onRemove: () => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  selectedFile,
  onRemove,
}) => {
  if (!selectedFile) return null;

  const isImage = selectedFile.type.startsWith("image/");
  const fileSize = (selectedFile.size / 1024).toFixed(2);

  return (
    <div className="px-6 py-3 bg-gray-50 border-t border-gray-100">
      <div className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-200">
        <div className="flex items-center space-x-3 flex-1 min-w-0">
          {isImage ? (
            <img
              src={URL.createObjectURL(selectedFile)}
              alt="Preview"
              className="w-12 h-12 object-cover rounded"
            />
          ) : (
            <div className="w-12 h-12 bg-blue-100 rounded flex items-center justify-center">
              <Paperclip size={20} className="text-blue-600" />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {selectedFile.name}
            </p>
            <p className="text-xs text-gray-500">{fileSize} KB</p>
          </div>
        </div>
        <button
          onClick={onRemove}
          className="ml-3 text-gray-400 hover:text-gray-600"
        >
          <span className="text-lg">×</span>
        </button>
      </div>
    </div>
  );
};

export default FilePreview;
